import { Check } from "lucide-react";
import { IDS } from "@/lib/testIds";

const STEPS = [
  { n: 1, label: "Understand" },
  { n: 2, label: "Share details" },
  { n: 3, label: "Receive report" },
];

// Non-interactive progress indicator. `current` = 2 on /start, 3 on confirmation.
export function StepProgress({ current }) {
  const statusFor = (n) =>
    n < current ? "Complete" : n === current ? "Current" : "Next";
  const active = STEPS.find((s) => s.n === current);

  return (
    <div data-testid={IDS.stepProgress} className="w-full">
      {active && (
        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-teal-deep">
          Step {active.n} — {active.label}
        </p>
      )}
      <ol className="mt-3 flex items-start">
        {STEPS.map((s, i) => {
          const status = statusFor(s.n);
          const isComplete = status === "Complete";
          const isCurrent = status === "Current";
          return (
            <li key={s.n} className="flex flex-1 items-start last:flex-none">
              <div className="flex flex-col items-center text-center">
                <span
                  className={`flex h-8 w-8 items-center justify-center rounded-full border text-[13px] font-semibold transition-colors ${
                    isComplete
                      ? "border-teal bg-teal text-white"
                      : isCurrent
                      ? "border-ink bg-ink text-stone-soft"
                      : "border-muted-line bg-stone-soft text-muted"
                  }`}
                >
                  {isComplete ? <Check className="h-4 w-4" strokeWidth={2.4} /> : s.n}
                </span>
                <span
                  className={`mt-2 text-[12.5px] font-medium ${
                    isCurrent ? "text-ink" : "text-ink-soft"
                  }`}
                >
                  {s.label}
                </span>
                <span
                  className={`mt-0.5 text-[11px] uppercase tracking-[0.1em] ${
                    isComplete
                      ? "text-teal-deep"
                      : isCurrent
                      ? "text-amber-deep"
                      : "text-muted"
                  }`}
                >
                  {status}
                </span>
              </div>
              {i < STEPS.length - 1 && (
                <span
                  className={`mt-4 h-[2px] flex-1 ${
                    s.n < current ? "bg-teal" : "bg-muted-line"
                  }`}
                />
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
